export default __webpack_public_path__ + "static/media/10.94499c2f.jpg";